import React, { Component } from 'react'
import { connect } from 'react-redux'
import { identity, partial } from 'lodash'

import { getAuthenticationVM } from 'state/viewModels'
import * as actions from 'ducks/modules/customize'
import ControlledRadioGroup from 'components/ControlledRadioGroup'
import { TrackedButtonLink, TrackedButton} from 'components/Buttons'

export class AuthenticationForm extends Component {

  constructor() {
    super();
    this.state = { valid: true };
    this.checkValid = this.checkValid.bind(this);
  }

  checkValid() {
    this.setState( {valid: this.props.validation.valid} );
  }

  componentWillReceiveProps(nextProps)
  {
    this.setState( {valid: nextProps.validation.valid} );
  }

  render = () => (<div>
    <div className="customize-form-header">Authentication</div>
    <div className="customize-form-section">
        <ControlledRadioGroup
            radioGroup="authentication"
            selected={this.props.selected}
            options={this.props.options}
            showPrice={true}
            isError={!this.state.valid}//{this.props.showValidationWarnings && !this.props.validation.valid}
            onChange={partial(this.props.onFieldChange, 'authentication')}
        />
    </div>
    <div className="customize-form-section">
      {this.props.validation.valid &&
        <TrackedButtonLink trackingData="Next:Confirm" className="next" to="confirm">next: confirm</TrackedButtonLink>
      }
      {!this.props.validation.valid &&
        <TrackedButton trackingData="Next:Confirm" className="next" onClick={this.checkValid}>next: confirm</TrackedButton>
      }
    </div>
    {!this.state.valid &&
      <div className="error">Please complete all selections above before going to another page.</div>
    }
    {/*
    <NavWarning when={!this.props.validation.valid}
        message="Please fix the errors above before going to another page" />
    */}
  </div>
  )
}

AuthenticationForm.defaultProps = {
    onFieldChange: identity,
};

const mapStateToProps = (state, ownProps) => {
  var p = { ...getAuthenticationVM(state.customize) }
  p.showValidationWarnings = state.app.blockedNavigation && !p.validation.valid
  return p;
}

const mapDispatchToProps = {
    onFieldChange: actions.selectField,
}

export default connect(mapStateToProps, mapDispatchToProps)(AuthenticationForm);